module.exports = __webpack_public_path__ + "img/login-off.d6d3bb09.jpg";